import React from 'react';

import {
  PauseCircleIcon,
  StopCircleIcon,
  PlayCircleIcon,
  VideoOnIcon,
  LoaderIcon,
  ClockIcon,
  CheckIcon,
  PauseIcon,
  RefreshRightIcon,
  AttentionTriangleIcon,
  WeatherCloudOffIcon,
  EyeOffIcon,
  DeleteIcon,
  CrossIcon,
  EyeOnIcon,
} from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { pauseStream, startStream, stopStream } from '../../../../../../entities/sources/luna-streams/store/streams';
import st from './cells.module.sass';

const buttonPropTypes = {
  onClick: PropTypes.func.isRequired,
  value: PropTypes.shape({
    streamId: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
  }).isRequired,
};

const defaultButtonPropTypes = {};

function StartCellComponent({
  onClick,
  value: {
    streamId,
    disabled,
  },
}) {
  const { t } = useTranslation();
  return (
    <Control.IconButton
      data-testid="button-play"
      disabled={disabled}
      icon={<PlayCircleIcon data-testid="icon-play" />}
      kind="secondary"
      onClick={() => onClick(streamId)}
      title={t('lunaStreamsStreams:таблица.действия.старт')}
      variant="dimmed"
    />
  );
}

StartCellComponent.propTypes = buttonPropTypes;
StartCellComponent.defaultProps = defaultButtonPropTypes;

export const StartCell = connect(() => ({}), (dispatch) => ({
  onClick: (streamId) => dispatch(startStream(streamId)),
}))(StartCellComponent);

function PauseCellComponent({
  onClick,
  value: {
    streamId,
    disabled,
  },
}) {
  const { t } = useTranslation();
  return (
    <Control.IconButton
      data-testid="button-pause"
      disabled={disabled}
      icon={<PauseCircleIcon data-testid="icon-pause" />}
      kind="secondary"
      onClick={() => onClick(streamId)}
      title={t('lunaStreamsStreams:таблица.действия.пауза')}
      variant="dimmed"
    />
  );
}

PauseCellComponent.propTypes = buttonPropTypes;
PauseCellComponent.defaultProps = defaultButtonPropTypes;

export const PauseCell = connect(() => ({}), (dispatch) => ({
  onClick: (streamId) => dispatch(pauseStream(streamId)),
}))(PauseCellComponent);

function StopCellComponent({
  onClick,
  value: {
    streamId,
    disabled,
  },
}) {
  const { t } = useTranslation();
  return (
    <Control.IconButton
      data-testid="button-stop"
      disabled={disabled}
      icon={<StopCircleIcon data-testid="icon-stop" />}
      kind="secondary"
      onClick={() => onClick(streamId)}
      title={t('lunaStreamsStreams:таблица.действия.стоп')}
      variant="dimmed"
    />
  );
}

StopCellComponent.propTypes = buttonPropTypes;
StopCellComponent.defaultProps = defaultButtonPropTypes;

export const StopCell = connect(
  () => ({}),
  (dispatch) => ({
    onClick: (streamId) => dispatch(stopStream(streamId)),
  }),
)(StopCellComponent);

function WatchLiveStreamCell({
  value,
}) {
  const { t } = useTranslation();

  return (
    <Control.LinkButton
      aria-label="VideoIcon"
      href={value}
      kind="secondary"
      rel="noopener noreferrer"
      round
      target="_blank"
      title={t('lunaStreamsStreams:таблица.действия.liveStream')}
      variant="dimmed"
    >
      <VideoOnIcon className="Button__Icon" />
    </Control.LinkButton>
  );
}

WatchLiveStreamCell.defaultProps = {
  value: undefined,
};

export { WatchLiveStreamCell };

function ViewStreamCell({
  value,
}) {
  const { t } = useTranslation();
  return (
    <Control.LinkButton
      aria-label="VideoIcon"
      disabled={!value}
      href={value}
      rel="noopener noreferrer"
      round
      target="_blank"
      title={t('lunaStreamsStreams:таблица.действия.view')}
      variant="dimmed"
    >
      <EyeOnIcon className="Button__Icon" />
    </Control.LinkButton>
  );
}

ViewStreamCell.defaultProps = {
  value: undefined,
};

export { ViewStreamCell };

function StatusCell({ value }) {
  const iconsMap = {
    pending: <ClockIcon className={cn(st.Icon)} />,
    in_progress: <LoaderIcon className={cn(st.Icon, st.success)} />,
    done: <CheckIcon className={cn(st.Icon, st.success)} />,
    pause: <PauseIcon className={cn(st.Icon)} />,
    restart: <RefreshRightIcon className={cn(st.Icon)} />,
    cancel: <CrossIcon className={cn(st.Icon)} />,
    failure: <AttentionTriangleIcon className={cn(st.Icon, st.error)} />,
    handler_lost: <WeatherCloudOffIcon className={cn(st.Icon, st.error)} />,
    not_found: <EyeOffIcon className={cn(st.Icon, st.error)} />,
    deleted: <DeleteIcon className={cn(st.Icon, st.error)} />,
  };

  if (iconsMap[value.value] === undefined) {
    return (
      <div className={st.StatusCell}>
        {value.label}
      </div>
    );
  }

  return (
    <div className={st.StatusCell} title={value.label}>
      {iconsMap[value.value]}
      {value.label}
    </div>
  );
}

StatusCell.propTypes = {
  value: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
};

export { StatusCell };
